
import { Grid } from "@mui/material";
import CustomDialog from "../../commons/dialog/customDialog";
import { StyledForm } from "../../styled/form";
import EditFormHeader from "./headers/editFormHeader";
import NewFormHeader from "./headers/newFormHeader";

const FormDialogWrapper = ({
  children,
  openForm,
  handleDialogClose,
  selectedDocument,
  handleClose,
  formTitle,
  loadingForm,
  idSiniestro,
  artName,
  commonProperties,
  errorLoadingForm,
  isDialog = true,
}) => {

  if (!isDialog) {
    return (
      <Grid container>
        <Grid item xs={12}>
          <NewFormHeader formName={formTitle} loading={loadingForm && !errorLoadingForm} />
        </Grid>

        <Grid item xs={12} sx={{ height: "100%" }} >
          {children}
        </Grid>
      </Grid>
    );
  }
  return (
    <CustomDialog
      open={!!openForm}
      onClose={handleDialogClose}
      fullWidth
      maxWidth="lg"
    >

      {selectedDocument ? (
        <EditFormHeader
          handleClose={handleClose}
          commonProperties={commonProperties}
          artName={artName}
          idSiniestro={idSiniestro}
        />
      ) : (
        <NewFormHeader formName={formTitle} handleClose={handleDialogClose} loading={loadingForm && !errorLoadingForm} />
      )}
      <StyledForm.DialogContentStyled>
        {children}
      </StyledForm.DialogContentStyled>
    </CustomDialog>
  )
}

export default FormDialogWrapper;